import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-718dbc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analysis" }
const _hoisted_2 = {
  id: "analysis-chart",
  ref: "analysisChart"
}
const _hoisted_3 = { class: "no-data" }
const _hoisted_4 = { id: "chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _ctx.noDataShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
        [_vShow, !_ctx.noDataShow]
      ])
    ], 512)
  ]))
}